// İSG uzmanı portalı — kabuk (Admin/Ayarlar/Ziyaretçiler) birincil aksiyon köprüsü (S33 Slice 5,
// owner kararı — plan `docs/plans/S33-carbon-reskin.md` Slice 5 "the shells own the header ...
// with the ACTIVE tab's primary action on the right"). Kabuk KENDİ Breadcrumb+PageHeader'ını
// taşır (tek gerçek `<h1>`); ama `PageHeader`'ın sağındaki birincil aksiyon (ör. "Yeni Şube") HER
// sekmede FARKLI ve o sekmenin KENDİ yerel state'ine (bir modal aç/kapa `useState`'i) bağlı —
// kabuk bu düğmeyi kendi başına İNŞA EDEMEZ, yalnız sekme sayfası kurabilir.
//
// **Mekanizma — DOM portalı, context/state-lifting DEĞİL.** Kabuk `PageHeader.actions`'a boş bir
// hedef `<div>` (ref'i taşıyan) verir ve bu ref'i `Outlet`'in üstüne context'le geçirir; sekme
// sayfası kendi `Button`'ını `<ShellHeaderAction>` ile bu hedefe PORTAL'lar
// (`react-dom`'un `createPortal`'ı — buton fiziksel olarak PageHeader'ın İÇİNDE render edilir,
// React ağacında ise hâlâ sekme sayfasının çocuğudur, yani `onClick`'i sekmenin KENDİ yerel
// state'ine sorunsuz erişir). Rota değişince eski sekme unmount olur → portal'ı React KENDİLİĞİNDEN
// kaldırır; yeni sekme (varsa) kendi aksiyonunu portal'lar — kabukta hiçbir kayıt/temizlik kodu
// GEREKMEZ. Aksiyonu OLMAYAN sekmeler (ör. Ziyaret geçmişi, Mobil Uygulama Bağlantıları — Kaydet
// formun kendi altında kalır) `<ShellHeaderAction>` hiç KULLANMAZ; hedef boş `<div>` hiçbir görsel
// yer KAPLAMAZ.
//
// Neden bu ve neden `useState`+`useEffect` "yukarı itme" (lifting) DEĞİL: state-lifting, her
// render'da YENİ bir `ReactNode` referansı üreten bir `action` değerini ebeveynin state'ine
// yazmayı gerektirir — referans her zaman FARKLI olduğundan (JSX her render'da yeniden
// oluşturulur) sonsuz render riski taşır (ebeveyn state günceller → yeniden render eder → çocuk
// efekti yeniden çalışır → ebeveyn state'i YİNE günceller). Portal bu sınıfı BAŞTAN elemektedir —
// hiçbir state kopyası, hiçbir senkronizasyon efekti YOK, yalnız bir DOM hedefi. App-local
// (`DetailLayout.tsx` emsali) — yalnız bu DÖRT kabuğun (Admin/Ayarlar/Ziyaretçiler/Çalışma İzni
// Tipleri, owner review B2 item 7'de eklenen dördüncüsü) tüketeceği bir mekanizma,
// `packages/shared` DEĞİL.

import {
  type ReactNode,
  type RefObject,
  createContext,
  useContext,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { createPortal } from 'react-dom';

const ShellHeaderActionSlotContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const ShellHeaderActionProvider = ShellHeaderActionSlotContext.Provider;

/**
 * Kabuk tarafı. `slot` → `PageHeader`'ın `actions` prop'una doğrudan geçirilir; `slotRef` →
 * `ShellHeaderActionProvider`'a (Outlet'i sarmalayan) değer olarak verilir.
 */
export function useShellHeaderActionSlot(): {
  slotRef: RefObject<HTMLDivElement | null>;
  slot: ReactNode;
} {
  const slotRef = useRef<HTMLDivElement | null>(null);
  return { slotRef, slot: <div ref={slotRef} className="flex items-center gap-2" /> };
}

/** Sekme sayfası tarafı — çocuğu (genelde tek bir `Button`) kabuğun `PageHeader` slotuna portal'lar. */
export function ShellHeaderAction({ children }: { children: ReactNode }) {
  const slotRef = useContext(ShellHeaderActionSlotContext);
  const [slotEl, setSlotEl] = useState<HTMLDivElement | null>(null);

  // `useLayoutEffect` (useEffect DEĞİL) — commit SONRASI, boyama ÖNCESİ çalışır; sekme
  // değişiminde eski aksiyonun bir kare görünüp SONRA kaybolması (görünür "flash") böyle önlenir.
  // Bağımlılık yalnız `slotRef` (kabuk hayatı boyunca STABİL, `useRef` garantisi) — sonsuz render
  // riski yok (yukarıdaki dosya başlığı notu).
  useLayoutEffect(() => {
    setSlotEl(slotRef?.current ?? null);
  }, [slotRef]);

  if (!slotEl) {
    return null;
  }
  return createPortal(children, slotEl);
}
